// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add this CSS to your existing Home.css or relevant stylesheet */
.circle-image {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  overflow: hidden; /* Ensure the image stays within the circle */
  margin: 50px auto 20px; /* Adjusted margin */
  border: 4px solid #f1675d; /* Border color and thickness */
}

.profile-section {
  text-align: center;
}

.social-icons {
  margin-top: 20px;
}

.social-icons a {
  color: #f1675d;
  margin-right: 15px; /* Increased margin */
  font-size: 30px; /* Increased font size */
}

.social-icons a:hover {
  color: #021945;
}

.resume-download-button {
  display: block;
  margin: 20px auto 50px; /* Adjusted margin */
  width: 250px; /* Increased width */
  padding: 15px; /* Increased padding */
  border: none;
  border-radius: 10px; /* Increased border-radius */
  font-family: monospace;
  background-color: #021945;
  color: #ffffff;
  cursor: pointer;
  font-size: 30px; /* Increased font size */
}

.resume-download-button:hover {
  background-color: #f1675d;
}

/* Add this CSS to your existing Home.css or relevant stylesheet */
.name {
  font-size: 36px; /* Increased font size */
}

.summary-text {
  font-size: 24px; /* Increased font size */
}

/* Add this CSS to your existing Home.css or relevant stylesheet */
.home {
  background-color: #232b2b; /* Set background color */
  color: white; /* Set font color */
  overflow-x: hidden;
}

@media (max-width: 768px) {
  .home {
    overflow-x: hidden;
  }

  .summary-text {
    font-size: 18px;
    margin-top: -20px; /* Increased font size */
  }
}

/* Add this CSS to your existing Home.css or relevant stylesheet */
.home.dark-mode {
  background-color: #232b2b; /* Dark mode background color */
  color: white; /* Dark mode font color */
}

.home.light-mode {
  background-color: #FBF0D9; /* Light mode background color */
  color: #021945; /* Light mode font color */
}

/* Add this CSS to your existing Home.css or relevant stylesheet */
.home.light-mode hr.divider {
  border-color: #021945; 
}

.home.light-mode .dark-mode-toggle svg {
  color: #f1675d; 
}

.dark-mode-toggle {
  position: absolute;
  top: 20px;
  right: 20px;
  background-color: transparent;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 35px;
}

.dark-mode-toggle:hover {
  color: #f1675d;
}

@media (max-width: 768px) {
  .dark-mode-toggle {
    right: 20px;
    top: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Home.css"],"names":[],"mappings":"AAAA,kEAAkE;AAClE;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB,EAAE,6CAA6C;EAC/D,sBAAsB,EAAE,oBAAoB;EAC5C,yBAAyB,EAAE,+BAA+B;AAC5D;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB,EAAE,qBAAqB;EACzC,eAAe,EAAE,wBAAwB;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,sBAAsB,EAAE,oBAAoB;EAC5C,YAAY,EAAE,oBAAoB;EAClC,aAAa,EAAE,sBAAsB;EACrC,YAAY;EACZ,mBAAmB,EAAE,4BAA4B;EACjD,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,eAAe,EAAE,wBAAwB;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kEAAkE;AAClE;EACE,eAAe,EAAE,wBAAwB;AAC3C;;AAEA;EACE,eAAe,EAAE,wBAAwB;AAC3C;;AAEA,kEAAkE;AAClE;EACE,yBAAyB,EAAE,yBAAyB;EACpD,YAAY,EAAE,mBAAmB;EACjC,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB,EAAE,wBAAwB;EAC7C;AACF;;AAEA,kEAAkE;AAClE;EACE,yBAAyB,EAAE,+BAA+B;EAC1D,YAAY,EAAE,yBAAyB;AACzC;;AAEA;EACE,yBAAyB,EAAE,gCAAgC;EAC3D,cAAc,EAAE,0BAA0B;AAC5C;;AAEA,kEAAkE;AAClE;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,WAAW;IACX,SAAS;EACX;AACF","sourcesContent":["/* Add this CSS to your existing Home.css or relevant stylesheet */\n.circle-image {\n  width: 200px;\n  height: 200px;\n  border-radius: 50%;\n  overflow: hidden; /* Ensure the image stays within the circle */\n  margin: 50px auto 20px; /* Adjusted margin */\n  border: 4px solid #f1675d; /* Border color and thickness */\n}\n\n.profile-section {\n  text-align: center;\n}\n\n.social-icons {\n  margin-top: 20px;\n}\n\n.social-icons a {\n  color: #f1675d;\n  margin-right: 15px; /* Increased margin */\n  font-size: 30px; /* Increased font size */\n}\n\n.social-icons a:hover {\n  color: #021945;\n}\n\n.resume-download-button {\n  display: block;\n  margin: 20px auto 50px; /* Adjusted margin */\n  width: 250px; /* Increased width */\n  padding: 15px; /* Increased padding */\n  border: none;\n  border-radius: 10px; /* Increased border-radius */\n  font-family: monospace;\n  background-color: #021945;\n  color: #ffffff;\n  cursor: pointer;\n  font-size: 30px; /* Increased font size */\n}\n\n.resume-download-button:hover {\n  background-color: #f1675d;\n}\n\n/* Add this CSS to your existing Home.css or relevant stylesheet */\n.name {\n  font-size: 36px; /* Increased font size */\n}\n\n.summary-text {\n  font-size: 24px; /* Increased font size */\n}\n\n/* Add this CSS to your existing Home.css or relevant stylesheet */\n.home {\n  background-color: #232b2b; /* Set background color */\n  color: white; /* Set font color */\n  overflow-x: hidden;\n}\n\n@media (max-width: 768px) {\n  .home {\n    overflow-x: hidden;\n  }\n\n  .summary-text {\n    font-size: 18px;\n    margin-top: -20px; /* Increased font size */\n  }\n}\n\n/* Add this CSS to your existing Home.css or relevant stylesheet */\n.home.dark-mode {\n  background-color: #232b2b; /* Dark mode background color */\n  color: white; /* Dark mode font color */\n}\n\n.home.light-mode {\n  background-color: #FBF0D9; /* Light mode background color */\n  color: #021945; /* Light mode font color */\n}\n\n/* Add this CSS to your existing Home.css or relevant stylesheet */\n.home.light-mode hr.divider {\n  border-color: #021945; \n}\n\n.home.light-mode .dark-mode-toggle svg {\n  color: #f1675d; \n}\n\n.dark-mode-toggle {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  background-color: transparent;\n  border: none;\n  color: white;\n  cursor: pointer;\n  font-size: 35px;\n}\n\n.dark-mode-toggle:hover {\n  color: #f1675d;\n}\n\n@media (max-width: 768px) {\n  .dark-mode-toggle {\n    right: 20px;\n    top: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
